import {
	Component,
	ChangeDetectionStrategy,
	Input,
	Output,
	EventEmitter,
} from '@angular/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
	selector: 'days-period-content',
	templateUrl: './days-period-content.component.html',
	styleUrls: ['./days-period-content.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [MatSlideToggleModule, NgxTolgeeModule],
})
export class DaysPeriodContentComponent {
	@Input() toggleValue: boolean;
	@Output() valueChanged = new EventEmitter<boolean>();
}
